import { StyleOptions } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

const defaultStyle = { id: 'sports-outrights-grid', type: 'theme' } as StyleOptions;

export const OutrightsGridLoader = {
    id: 'outrights-grid',
    loaderFn: () => import(/* webpackChunkName: "ms-outrights-widget" */ './outrights-grid.feature'),
    additionalStylesFn: (): StyleOptions[] => [defaultStyle],
    product: ClientConfigProductName.SPORTS,
};
